export * from './konstantes.service';
export * from './konstantes.service.module';